import { ModuleType } from "./Enums/ModyleType";
import { FormatUtils } from "./Utils/FormatUtils";
import Chart from "../config"
import {forEach} from "lodash/fp/_util";
/**
 * @author Louis Scheepers
 * Handles the creation and Rendering of chartisan chartjs charts.
 */
export class Charts {
    static backgroundColors() {
        this.blue = '#39ABD8';
        this.lightBlue = '#42BBEA';
        this.orange = '#FF9300';
        this.lightOrange = '#FD9C37';
        this.pink = '#CB0A73';
        this.lightPink = '#E50F83';
        this.darkPink = '#761267';
        this.lightDarkPink = '#991586';
        this.purple = '#4B1879';
        this.lightPurple = '#5B238D';
        return [this.blue, this.orange, this.pink, this.darkPink, this.purple, this.lightBlue, this.lightOrange, this.lightPink, this.lightDarkPink, this.lightPurple];
    }

    static colors() {
        this.blue = '#39ABD8';
        this.lightBlue = '#42BBEA';
        this.orange = '#FF9300';
        this.lightOrange = '#FD9C37';
        this.pink = '#CB0A73';
        this.lightPink = '#E50F83';
        this.darkPink = '#761267';
        this.lightDarkPink = '#991586';
        this.purple = '#4B1879';
        this.lightPurple = '#5B238D';

        return {
            'blue': this.blue,
            'lightBlue': this.lightBlue,
            'orange': this.orange,
            'lightOrange': this.lightOrange,
            'pink': this.pink,
            'lightPink': this.lightPink,
            'darkPink': this.darkPink,
            'lightDarkPink': this.lightDarkPink,
            'purple': this.purple,
            'lightPurple': this.lightPurple,
        }
    }

    static backgroundReverseAccents() {
        this.blue = '#39ABD8';
        this.lightBlue = '#42BBEA';
        this.orange = '#FF9300';
        this.lightOrange = '#FD9C37';
        this.pink = '#CB0A73';
        this.lightPink = '#E50F83';
        this.darkPink = '#761267';
        this.lightDarkPink = '#991586';
        this.purple = '#4B1879';
        this.lightPurple = '#5B238D';
        return [this.lightOrange, this.lightBlue, this.lightPink, this.lightDarkPink, this.purple, this.blue, this.orange, this.pink, this.darkPink, this.purple];
    }


    /**
     * Easy To Call Create Method
     * @param args
     * @returns {*}
     */
    static create(args) {
        return this.createFromModule(args);
    }

    /**
     * Chooses which chart to render based on the module
     * @param args
     * @returns {*}
     */
    static createFromModule(args) {
        switch (parseInt(args['module'])) {
            case ModuleType.CICO:
                return this.cashInCashOutChart(args);
            case ModuleType.INO:
                return this.incomeExpenseChart(args);
            case ModuleType.AVD:
                return this.assetDebt(args);
            case ModuleType.AR:
            case ModuleType.AP:
                return this.accountsReceivablePayable(args);
            case ModuleType.DDO:
            case ModuleType.CDO:
                return this.daysOutstanding(args);
            case ModuleType.TCS:
            case ModuleType.TSP:
                return this.topBalance(args);
            case ModuleType.PLR:
                return this.profitLossRatio(args);
            case ModuleType.BSR:
                return this.balanceSheetRatio(args);
            case ModuleType.IM:
                return this.inventoryManagement(args);
            case ModuleType.INAS:
                return this.inventoryAnalysisBySales(args);
            case ModuleType.INAQ:
                return this.inventoryAnalysisByQuantity(args);
            case ModuleType.RET:
                return this.retentionChart(args);
            default:
                break;
        }
    }

    /**
     * Cash In Cash Out Chart
     * @param args
     * @returns {Chartisan}
     */
    static cashInCashOutChart(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: datasets[2]['name'],
                        data: datasets[2]['values'],
                        backgroundColor: this.colors()['orange'],
                        borderColor: this.colors()['orange'],
                        borderWidth: 0,
                        fill: false,
                        type: 'line',
                    },
                    {
                        label: datasets[0]['name'],
                        data: datasets[0]['values'],
                        backgroundColor: this.colors()['blue'],
                        borderColor: this.colors()['blue'],
                        borderWidth: 0,

                    },
                    {
                        label: datasets[1]['name'],
                        data: datasets[1]['values'],
                        backgroundColor: this.colors()['pink'],
                        borderColor: this.colors()['pink'],
                        borderWidth: 0,
                    }
                ]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asCurrency("R", value);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", tooltip.yLabel);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });
    }

    /**
     * Income Expense Chart
     * @param args
     * @returns {Chart}
     */
    static incomeExpenseChart(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                        label: datasets[0]['name'],
                        data: datasets[0]['values'],
                        backgroundColor: this.colors()['orange'],
                        borderColor: this.colors()['orange'],
                        borderWidth: 0,
                        fill: false,
                        type: 'line',
                    },
                    {
                        label: datasets[1]['name'],
                        data: datasets[1]['values'],
                        backgroundColor: this.colors()['blue'],
                        borderColor: this.colors()['blue'],
                        borderWidth: 0,
                    },
                    {
                        label: datasets[2]['name'],
                        data: datasets[2]['values'],
                        backgroundColor: this.colors()['pink'],
                        borderColor: this.colors()['pink'],
                        borderWidth: 0,
                    }
                ]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asCurrency("R", value);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", tooltip.yLabel);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });
    }

    /**
     * Accounts Receivable and Accounts Payable Chart
     * @param args
     * @returns {Chart}
     */
    static accountsReceivablePayable(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    borderWidth: 0,
                    backgroundColor: this.backgroundColors(),
                    data: datasets[0]['values']
                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", tooltip.yLabel);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asCurrency("R", value);
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return FormatUtils.shortenLabel(value[0], 8);
                            }
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        });

    }

    /**
     * Debtors and Creditors days outstanding chart
     * @param args
     * @returns {Chart}
     */
    static daysOutstanding(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];


        return new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    data: [datasets[0]['values'][0], datasets[0]['values'][1], datasets[0]['values'][2], datasets[0]['values'][3], datasets[0]['values'][4]],
                    backgroundColor: this.backgroundReverseAccents(),
                    borderColor: this.backgroundColors(),
                    borderWidth: 0
                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", data.datasets[tooltip.datasetIndex].data[tooltip.index]);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            return value + ":)";
                        },
                        color: '#fff',
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 40,

            },
        });
    }


    /**
     * TopCustomers, TopSuppliers by balance chart
     * @param args
     * @returns {Chart}
     */
    static topBalance(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'horizontalBar',
            data: {
                labels: labels,
                datasets: [{

                    borderWidth: 0,
                    backgroundColor: this.backgroundColors(),
                    data: datasets[0]['values']
                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", tooltip.xLabel);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asCurrency("R", value);
                            }
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return FormatUtils.shortenLabel(value[0], 8);
                            }
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        });
    }

    /**
     * Asset V Debt Chart
     * @param args
     * @returns {Chart}
     */
    static assetDebt(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];

        return new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    data: [datasets[0]['values'][0], datasets[0]['values'][1]],
                    backgroundColor: this.backgroundReverseAccents(),
                    borderColor: this.backgroundColors(),
                    borderWidth: 0
                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", data.datasets[tooltip.datasetIndex].data[tooltip.index]);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            return value + ":)";
                        },
                        color: '#fff',
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 40,

            },
        });
    }

    /**
     * Cash In Cash Out Chart
     * @param args
     * @returns {Chart}
     */
    static profitLossRatio(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                        label: datasets[0]['name'],
                        data: datasets[0]['values'],
                        backgroundColor: this.colors()['lightPink'],
                        borderColor: this.colors()['pink'],
                        borderWidth: 0,
                        fill: false,
                    },
                    {
                        label: datasets[1]['name'],
                        data: datasets[1]['values'],
                        backgroundColor: this.colors()['lightDarkPink'],
                        borderColor: this.colors()['darkPink'],
                        borderWidth: 0,
                        fill: false,
                    },
                    {
                        label: datasets[2]['name'],
                        data: datasets[2]['values'],
                        backgroundColor: this.colors()['lightPurple'],
                        borderColor: this.colors()['purple'],
                        borderWidth: 0,
                        fill: false,
                    }
                ]
            },
            options: {
                animation: args['animation'],
                legend: {
                    display: true,
                    position: "bottom",
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asPercentage(value * 100);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asPercentage(tooltip.yLabel, 2);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });

    }

    /**
     * Cash In Cash Out Chart
     * @param args
     * @returns {Chart}
     */
    static balanceSheetRatio(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                        label: datasets[0]['name'],
                        data: datasets[0]['values'],
                        backgroundColor: this.colors()['lightPink'],
                        borderColor: this.colors()['pink'],
                        borderWidth: 0,
                        fill: false,
                    },
                    {
                        label: datasets[1]['name'],
                        data: datasets[1]['values'],
                        backgroundColor: this.colors()['lightDarkPink'],
                        borderColor: this.colors()['darkPink'],
                        borderWidth: 0,
                        fill: false,
                    },
                ]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                legend: {
                    display: true,
                    position: "bottom",
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.withDecimals(value, 0);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.withDecimals(tooltip.yLabel, 2);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });

    }

    /**
     * Inventory Management chart
     * @param args
     * @returns {Chart}
     */
    static inventoryManagement(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];


        return new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    data: [datasets[0]['values'][0], datasets[0]['values'][1], datasets[0]['values'][2]],
                    backgroundColor: this.backgroundReverseAccents(),
                    borderColor: this.backgroundColors(),
                    borderWidth: 0
                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return data.datasets[tooltip.datasetIndex].data[tooltip.index];
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            return value + ":)";
                        },
                        color: '#fff',
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 40,
            },
        });
    }

    /**
     * Inventory Analysis Chart
     * @param args
     * @returns {Chartisan}
     */
    static inventoryAnalysisBySales(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: datasets[0]['name'],
                    data: datasets[0]['values'],
                    backgroundColor: this.colors()['orange'],
                    borderColor: this.colors()['orange'],
                    borderWidth: 0,

                }, ]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asCurrency("R", value);
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return FormatUtils.shortenLabel(value, 16);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asCurrency("R", tooltip.yLabel);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });

    }

    /**
     * Inventory Analysis Chart
     * @param args
     * @returns {Chartisan}
     */
    static inventoryAnalysisByQuantity(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: datasets[0]['name'],
                    data: datasets[0]['values'],
                    backgroundColor: this.colors()['orange'],
                    borderColor: this.colors()['orange'],
                    borderWidth: 0,

                }, ]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                if (ModuleType.INAS === parseInt(args['module'])) {
                                    return FormatUtils.asCurrency("R", value);
                                }

                                return value;
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            callback: function(value, index, values) {
                                return FormatUtils.shortenLabel(value, 16);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {

                            if (ModuleType.INAS === parseInt(args['module'])) {
                                return FormatUtils.asCurrency("R", tooltip.yLabel);
                            }

                            return tooltip.yLabel;

                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });
    }

    /**
     * Retention Chart
     * @param args
     * @returns {Chartisan}
     */
    static retentionChart(args) {
        this.swapLoader(args);
        let ctx = document.getElementById('chart' + args['id']);
        let data = args['data'];
        let datasets = data['datasets'];
        let labels = data['chart']['labels'];
        return new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: datasets[0]['name'],
                    data: datasets[0]['values'],
                    backgroundColor: this.colors()['blue'],
                    borderColor: this.colors()['blue'],
                    borderWidth: 0,

                }]
            },
            options: {
                animation: {
                    duration: (args['animation']) ? 1000 : 0,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    }
                },
                legend: {
                    display: false,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            stepSize: this.getStepSize(this.getHighestValue(datasets)),
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return FormatUtils.asPercentage(value);
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltip, data) {
                            return FormatUtils.asPercentage(tooltip.yLabel, 2);
                        },
                        title: function(tooltip, data) {
                            return tooltip[0]["label"].replace("\n", " ");
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
            },

        });
    }

    static swapLoader(args) {
        $("#loader" + args['id']).hide();
        $("#chart" + args['id']).show();
    }

    static getStepSize(highest) {
        let stepSize = highest / 5;

        return Math.round(stepSize);
    }

    static getHighestValue(datasets) {
        let highest = 0;
        for (let i = 0; i < datasets.length; i++) {
            highest = Math.max(...datasets[i].values) > highest ? Math.max(...datasets[i].values) : highest;
        }
        return highest;
    }


}
